import unwrap from '../functions/unwrap';
import useRealtimeDatabase from './useRealtimeDatabase';

export default function useTripEzCaterEventsOutgoing(tripData) {
  return useRealtimeDatabase(
    unwrap(tripData, data =>
      unwrap(data.ezCaterDeliveryId, id => ({
        path: '/events-outgoing',
        orderByChild: 'requestBody/variables/input/deliveryId',
        equalTo: id,
      })),
    ) || {
      path: null,
    },
  );
}
